import {makeTrackEvent} from './makeTrackEvent';

export type CrossProjectRunsAction =
  | 'Workspace with cross-project runs loaded'
  | 'Cross-project runs drawer submitted'
  | 'Unpin cross-project run'
  | 'Set cross-project run as baseline'
  | 'Remove cross-project run as baseline';

export const trackCrossProjectPinnedRuns = makeTrackEvent<
  {
    action: CrossProjectRunsAction;
    numForeignRuns?: number;
    numDistinctProjects?: number;
    numRunsAdded?: number;
    numRunsRemoved?: number;
  },
  {
    action: {
      description: 'the interaction that occurred';
    };
    numForeignRuns: {
      description: 'number of pinned runs that belong to a project other than the workspace project (on workspace load)';
    };
    numDistinctProjects: {
      description: 'number of distinct foreign projects represented by pinned cross-project runs (on workspace load)';
    };
    numRunsAdded: {
      description: 'number of runs newly pinned as a result of submitting the cross-project runs drawer';
    };
    numRunsRemoved: {
      description: 'number of runs unpinned as a result of submitting the drawer';
    };
    _description: 'Tracks usage of the cross-project pinned runs feature in the run selector';
    _location: 'multi-run / group / sweep workspace run selector';
    _motivation: 'Measure adoption and usage patterns of the cross-project pinned runs feature';
  }
>('Cross-project pinned runs');
